if (!window.customElements.get('xgen-recommendations')) {
  const onlyUnique = (value, index, self) => {
    return self.indexOf(value) === index
  }
  class XGenRecommendations extends HTMLElement {

    constructor() {
      super();
      this.pageSize = 8;
    }

    connectedCallback() {
      this.id = this.getAttribute('id');
      this.experienceId = this.getAttribute('data-experience-id');
      this.pageSize = Number(this.getAttribute('data-page-size')) || 8;
      this.sectionId = this.getAttribute('data-section-id');
      this.includeRecentlyViewed = this.getAttribute('data-include-recently-viewed') === 'true';
      this.excludeCartProducts = this.getAttribute('data-exclude-cart-products') === 'true';
      this.excludeProducts = this.getAttribute('data-exclude-products') || '';
      this.productCode = this.getAttribute('data-product-code');
      this.targetProductCode = this.getAttribute('data-target-product-code');
      this.hideOos = this.getAttribute('data-hide-oos') === 'true';
      if (this.experienceId) this.runWhenMarketingAllowed(() => this.get())

      this.addEventListener('click', (e) => {
        const card = e.target.closest('[data-product-id]');
        if (card && this.contains(card)) {
          const itemId = card.dataset.productId;
          if (itemId && this.renderedItemIds && window.xgenCommon) {
            window.xgenCommon.pushEvent({
              event: 'elementClick',
              data: {
                element: {
                  id: this.experienceId,
                  items: this.renderedItemIds
                },
                item: itemId
              }
            });
          }
        }
      });
    }

    runWhenMarketingAllowed(fn) {
      if (!window.theme?.consentGating || !window.lovisaConsent) {
        fn()
        return
      }
      const run = () => {
        if (window.lovisaConsent.hasMarketing()) fn()
      }
      window.lovisaConsent.onConsentReady(run)
      window.addEventListener('lovisa:consent-updated', run)
    }

    get() {
      if (!this.experienceId) return
      if (!window.xgenCommon) return
      const queryObject = {
        ids: [this.experienceId]
      }
      if (!this.includeRecentlyViewed && localStorage.getItem('recentlyViewed')) {
        // Add recently viewed to recommendations
        const recentlyViewed = window.recentProducts.get()
        if (recentlyViewed && recentlyViewed.length) {
          queryObject.recentlyViewed = recentlyViewed.map((viewedItem) => {
            return viewedItem.id
          })//.join('|')
        }
      }
      if (!this.excludeCartProducts && window.theme.cartPage?.cart?.items) {
        // Exclude cart items from recommendations
        queryObject.exclude = queryObject.exclude || []
        queryObject.exclude = queryObject.exclude.concat(window.theme.cartPage.cart.items.map((cartItem) => {
          return cartItem.product_id
        }).filter(onlyUnique))//.join('|')
      }
      if (this.excludeProducts) {
        // Exclude products from recommendations
        queryObject.exclude = queryObject.exclude || []
        queryObject.exclude = queryObject.exclude.concat(this.excludeProducts.split(',').map((productId) => {
          return productId
        }).filter(onlyUnique))//.join('|')
      }
      if (this.productCode) {
        // Product code from recommendations
        queryObject.productCode = this.productCode
      }
      if (!this.productCode && this.targetProductCode) {
        // Target product code from recommendations
        queryObject.targetProductCode = this.targetProductCode
      }

      window.xgenCommon.recommend(queryObject).then(results => {
        const result = results[this.experienceId]
        let items = result.items
        if (this.hideOos) {
          items = items.filter((item) => {
            if (item.hasOwnProperty('available') && !item.available) {
              return false
            }
            if (item.hasOwnProperty('is_in_stock') && (item.is_in_stock !== "1" && item.is_in_stock !== "true" && item.is_in_stock !== 1 && item.is_in_stock !== true)) {
              return false
            }
            return true
          })
        }
        items = items.slice(0, this.pageSize)
        result.items = items
        if (result) this.render(result)
      })
    }
    render(result) {
      if (this.slider) {
        if (this.slider.destroy) this.slider.destroy()
        if (this.slider.unslick) this.slider.unslick()
        if (this.slider.slick) this.slider.slick('unslick');
      }
      this.productWrap = this.querySelector('[data-product-wrap]') || this;
      const isSlider = !!this.querySelector('[data-slider]');
      const gridSizing = isSlider ? 'swiper-slide grid__item medium-up--one-fifth' : 'grid__item medium-up--one-fifth';

      this.productWrap.innerHTML = result.items.map(item => {
        const product = window.xgenCommon.unifyProduct(item)
        return window.renderProductCard(product, { gridSizing })
      }).join('')
      if (this.productWrap.querySelector('.product-card')) {
        this.productWrap.querySelectorAll('.product-card').forEach(productCard => {
          new window.theme.ProductCard(productCard);
        })
      }

      // XGen Tracking
      try {
        const itemIds = result.items.map(i => i.prod_code || i.code || i.id);
        const eventData = {
          element: {
            id: this.experienceId,
            items: itemIds
          }
        };

        window.xgenCommon.pushEvent({ event: 'elementRender', data: eventData });

        if ('IntersectionObserver' in window) {
          const observer = new IntersectionObserver((entries, observer) => {
            entries.forEach(entry => {
              if (entry.isIntersecting) {
                window.xgenCommon.pushEvent({ event: 'elementView', data: eventData });
                observer.unobserve(entry.target);
              }
            });
          }, { threshold: 0.2 });
          observer.observe(this.productWrap);
        } else {
          window.xgenCommon.pushEvent({ event: 'elementView', data: eventData });
        }
      } catch (e) {
        console.error('XGen Tracking Error', e);
      }
      if (this.classList.contains("hybrid-recommendations")) {
        this.initSwiper()
      } else {
        this.initSlick()
      }

      if (result && result.items && result.items.find((item) => { return item.price_currency !== Shopify.currency.active }) && typeof window.getProductPrices === 'function') {
        console.log('XGen results not in currency ' + Shopify.currency.active + '. Fetching product prices.')
        const variantIds = [];
        result.items.forEach(item => {
          const product = window.xgenCommon.unifyProduct(item);
          if (product.variants) {
            product.variants.forEach(v => {
              if (v.id) {
                variantIds.push(v.id.toString().replace('gid://shopify/ProductVariant/', ''));
              }
            });
          }
        });
        if (variantIds.length) {
          window.getProductPrices([...new Set(variantIds)]);
        }
      }
    }

    initSlick() {
      const slickContainer = this.querySelector('[data-product-wrap]');
      const isSlider = !!this.querySelector('[data-slider]');
      if (isSlider && slickContainer && this.productWrap.children.length) {
        const hasArrows = true;
        const hasDots = slickContainer.getAttribute('data-slider-dots') && slickContainer.getAttribute('data-slider-dots') !== 'false';

        const gridMedium = window.theme && window.theme.settings && window.theme.settings.grid_medium ? Number(window.theme.settings.grid_medium.replace('px', '')) : 768;
        const gridLarge = window.theme && window.theme.settings && window.theme.settings.grid_large ? Number(window.theme.settings.grid_large.replace('px', '')) : 1024;

        const slickOptions = {
          slidesToShow: 2.4,
          slidesToScroll: 2,
          mobileFirst: true,
          dots: hasDots,
          arrows: hasArrows,
          infinite: false,
          responsive: [
            {
              breakpoint: gridMedium,
              settings: {
                slidesToShow: 3,
                slidesToScroll: 3,
                arrows: hasArrows,
              }
            },
            {
              breakpoint: gridLarge,
              settings: {
                slidesToShow: 5,
                slidesToScroll: 5,
                arrows: hasArrows,
              }
            }
          ]
        };
        if (hasArrows) {
          const prevArrow = this.querySelector('.slider__arrow-prev')
          const nextArrow = this.querySelector('.slider__arrow-next')
          slickOptions.prevArrow = prevArrow
          slickOptions.nextArrow = nextArrow
          slickOptions.responsive.forEach(breakpoint => {
            breakpoint.settings.prevArrow = prevArrow
            breakpoint.settings.nextArrow = nextArrow
          })
        }

        this.slider = $(this.productWrap).slick(slickOptions);
      }
    }

    initSwiper() {
      const swiperContainer = this.querySelector('[data-slider]');
      if (swiperContainer && this.productWrap.children.length) {
        const hasArrows = swiperContainer.getAttribute('data-slider-arrows') === 'true';
        const hasDots = swiperContainer.getAttribute('data-slider-dots') === 'true';

        const gridMedium = window.theme && window.theme.settings && window.theme.settings.grid_medium ? Number(window.theme.settings.grid_medium.replace('px', '')) : 768;
        const gridLarge = window.theme && window.theme.settings && window.theme.settings.grid_large ? Number(window.theme.settings.grid_large.replace('px', '')) : 1024;

        const swiperOptions = {
          direction: 'horizontal',
          loop: true,
          freeMode: true,
          slidesPerView: 2.3,
          spaceBetween: 0,
          autoHeight: false,
          breakpoints: {
            [gridMedium]: {
              slidesPerView: 4,
              spaceBetween: 8
            }
          },
          on: {
            sliderFirstMove: (swiper) => {
              swiper.el.classList.add('is-swiping');
            }
          }

        };

        if (hasArrows) {
          swiperOptions.navigation = {
            nextEl: '.swiper-button-next',
            prevEl: '.swiper-button-prev',
          };
        }

        if (hasDots) {
          swiperOptions.pagination = {
            el: '.swiper-pagination',
            clickable: true,
          };
        }

        this.slider = new Swiper('#' + this.id + ' [data-slider]', swiperOptions);
      }
    }
  }

  customElements.define('xgen-recommendations', XGenRecommendations);
}